import { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../../Api/Api";

const buildOrderFilters = (
  estimatedDeliveryDate,
  realDeliveryDate,
  currentOrders,
  isEstimatedDate,
  orderId,
) => {
  const currentOrder = {
    id: {
      $eq: orderId,
    },
  };
  const baseFilter = {
    $and: [
      {
        realDeliveryDate: { $null: true },
        estimatedDeliveryDate: { $null: true },
      },
    ],
  };

  const dateFilter = isEstimatedDate
    ? estimatedDeliveryDate
      ? {
          estimatedDeliveryDate: { $eq: estimatedDeliveryDate },
        }
      : {}
    : realDeliveryDate
      ? {
          realDeliveryDate: { $eq: realDeliveryDate },
        }
      : {};

  const orderFilters =
    currentOrders?.length > 0 ? { id: { $in: currentOrders } } : {};

  return {
    $or: [currentOrder, baseFilter, dateFilter, orderFilters],
  };
};

export const useOrdersData = (
  estimatedDeliveryDate,
  realDeliveryDate,
  currentOrders,
  isEstimatedDate,
  orderId,
) => {
  const { t } = useTranslation("common");
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await API.get("/api/commandes", {
        params: {
          fields: ["number", "id"],
          sort: "number:desc",
          filters: buildOrderFilters(
            estimatedDeliveryDate,
            realDeliveryDate,
            currentOrders,
            isEstimatedDate,
            orderId,
          ),
        },
      });

      const formattedOrders =
        data.data?.map((order) => ({
          label: t("Order") + " #" + order?.attributes?.number,
          value: order.id,
        })) || [];

      setOrders(formattedOrders);
    } catch (err) {
      console.error("Failed to fetch orders:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [
    estimatedDeliveryDate,
    realDeliveryDate,
    t,
    currentOrders,
    isEstimatedDate,
    orderId,
  ]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  return {
    orders,
    loading,
    error,
    refetchOrders: fetchOrders,
  };
};
